<template>
  <b-container fluid>
    <b-row no-gutters style="width: 100%">
      <b-card no-body class="col-12" v-if="activeItem" border-variant="primary">
        <b-card-header
          header-bg-variant="primary"
          header-text-variant="white"
          header-tag="h3"
          class="category-header"
        >
          Category
          <b-button-toolbar class="float-md-right">
            <b-button-group size="sm" class="mx-1">
              <b-input-group size="sm">
                <b-form-input
                  v-model="treeFilter"
                  class="text-right"
                  placeholder="Highlight Items"
                ></b-form-input>
              </b-input-group>

              <b-dropdown
                right
                split
                title="Reload Selected Tree"
                variant="light"
                size="sm"
                @click="getTopology({ reloadActiveEntityLevel: true })"
              >
                <template v-slot:button-content>
                  <b-icon
                    icon="arrow-repeat"
                    variant="info"
                    aria-hidden="true"
                  ></b-icon>
                </template>

                <b-dropdown-item-button @click="getTopology({})">
                  <b-icon
                    icon="arrow-repeat"
                    variant="info"
                    aria-hidden="true"
                  ></b-icon>
                  Refresh Entire Tree
                </b-dropdown-item-button>
              </b-dropdown>
            </b-button-group>
          </b-button-toolbar>
        </b-card-header>
        <b-card-body class="scrollable-tree category-tree">
          <b-row no-gutters style="width: 100%" v-if="topologyTreeLoadding">
            <loading-text v-if="topologyTreeLoadding"></loading-text>
          </b-row>
          <b-row no-gutters style="width: 100%" v-if="!topologyTreeLoadding">
            <b-card no-body class="col-12" v-if="treeCategories">
              <template v-for="category in treeCategories">
                <b-card-header
                  :class="['p-1', 'card-header-mobile', { 'not-visible': !category.Visible }]"
                  :key="'header' + category.CategoryId"
                  header-tag="h5"
                  :header-bg-variant="
                    activeItem.entityLevel == entityLevel.Category &&
                    activeItem.CategoryId == category.CategoryId
                      ? 'primary'
                      : ''
                  "
                  :header-text-variant="
                    highlightedTreeItem(category, entityLevel.Category)
                      ? 'success'
                      : activeItem.entityLevel == entityLevel.Category &&
                        activeItem.CategoryId == category.CategoryId
                      ? 'white'
                      : ''
                  "
                  @click="clickCategory({ category })"
                >
                  <b-button
                    title="Open/Close"
                    variant="link"
                    size="sm"
                    @click.stop="toggleCategoryOpen({ category })"
                    v-if="
                      category.ProductClasses &&
                      category.ProductClasses.length > 0
                    "
                  >
                    <b-icon
                      :icon="category.open ? 'chevron-down' : 'chevron-right'"
                      :variant="
                        activeItem.entityLevel == entityLevel.Category &&
                        activeItem.CategoryId == category.CategoryId
                          ? 'white'
                          : ''
                      "
                      aria-hidden="true"
                    ></b-icon>
                  </b-button>

                  <b-button v-else title="No Children" variant="link" size="sm">
                    <b-icon icon="blank"></b-icon>
                  </b-button>
                  {{ category.DisplayName }}
                </b-card-header>
                <b-card-body
                  :class="{ 'not-visible': !category.Visible, 'sub-category-tree':true }"
                  v-if="category.ProductClasses && category.open"
                  :key="'body' + category.CategoryId"
                  :body-border-variant="
                    activeItem.entityLevel == entityLevel.Category &&
                    activeItem.CategoryId == category.CategoryId
                      ? 'primary'
                      : 'secondary'
                  "
                >
                  <b-row no-gutters style="width: 100%">
                    <b-card no-body class="col-12">
                      <template v-for="productClass in category.ProductClasses">
                        <b-card-header
                          :class="[
                            'p-1',
                            'card-header-mobile',
                            { 'not-visible': !productClass.Visible },
                          ]"
                          :key="'header' + productClass.ProductClassId"
                          header-tag="h5"
                          :header-bg-variant="
                            activeItem.entityLevel ==
                              entityLevel.ProductClass &&
                            activeItem.ProductClassId ==
                              productClass.ProductClassId
                              ? 'primary'
                              : ''
                          "
                          :header-text-variant="
                            highlightedTreeItem(
                              productClass,
                              entityLevel.ProductClass,
                            )
                              ? 'success'
                              : activeItem.entityLevel ==
                                  entityLevel.ProductClass &&
                                activeItem.ProductClassId ==
                                  productClass.ProductClassId
                              ? 'white'
                              : ''
                          "
                          @click="clickProductClass({ category, productClass })"
                        >
                          <b-button
                            title="Open/Close"
                            variant="link"
                            size="sm"
                            @click.stop="
                              toggleProductClassOpen({ productClass })
                            "
                            v-if="
                              productClass.ManufacturingSeries &&
                              productClass.ManufacturingSeries.length > 0
                            "
                          >
                            <b-icon
                              :icon="
                                productClass.open
                                  ? 'chevron-down'
                                  : 'chevron-right'
                              "
                              :variant="
                                productClass.entityLevel ==
                                  entityLevel.ProductClass &&
                                activeItem.ProductClassId ==
                                  productClass.ProductClassId
                                  ? 'white'
                                  : ''
                              "
                              aria-hidden="true"
                            ></b-icon>
                          </b-button>
                          <b-button
                            v-else
                            title="No Children"
                            variant="link"
                            size="sm"
                          >
                            <b-icon icon="blank"></b-icon>
                          </b-button>
                          {{ productClass.DisplayName }}
                        </b-card-header>
                        <b-card-body
                          :class="{ 'not-visible': !productClass.Visible, 'sub-category-tree':true  }"
                          v-if="productClass.open"
                          :key="'body' + productClass.ProductClassId"
                          :body-border-variant="
                            activeItem.entityLevel ==
                              entityLevel.ProductClass &&
                            activeItem.ProductClassId ==
                              productClass.ProductClassId
                              ? 'primary'
                              : 'secondary'
                          "
                        >
                          <b-row no-gutters style="width: 100%">
                            <b-card no-body class="col-12">
                              <template
                                v-for="manufacturingSeries in productClass.ManufacturingSeries"
                              >
                                <b-card-header
                                  :class="[
                                    'p-1',
                                    'card-header-mobile',
                                    {
                                      'not-visible':
                                        !manufacturingSeries.Visible,
                                    },
                                  ]"
                                  :key="
                                    'header' +
                                    manufacturingSeries.ManufacturingSeriesId
                                  "
                                  header-tag="h5"
                                  :header-bg-variant="
                                    activeItem.entityLevel ==
                                      entityLevel.ManufacturingSeries &&
                                    activeItem.ManufacturingSeriesId ==
                                      manufacturingSeries.ManufacturingSeriesId
                                      ? 'primary'
                                      : ''
                                  "
                                  :header-text-variant="
                                    highlightedTreeItem(
                                      manufacturingSeries,
                                      entityLevel.ManufacturingSeries,
                                    )
                                      ? 'success'
                                      : activeItem.entityLevel ==
                                          entityLevel.ManufacturingSeries &&
                                        activeItem.ManufacturingSeriesId ==
                                          manufacturingSeries.ManufacturingSeriesId
                                      ? 'white'
                                      : ''
                                  "
                                  @click="
                                    clickManufacturingSeries({
                                      category,
                                      productClass,
                                      manufacturingSeries,
                                    })
                                  "
                                >
                                  <b-button
                                    title="Open/Close"
                                    variant="link"
                                    size="sm"
                                    @click.stop="
                                      toggleManufacturingSeriesOpen({
                                        manufacturingSeries,
                                      })
                                    "
                                    v-if="
                                      manufacturingSeries.Products &&
                                      manufacturingSeries.Products.length > 0
                                    "
                                  >
                                    <b-icon
                                      :icon="
                                        manufacturingSeries.open
                                          ? 'chevron-down'
                                          : 'chevron-right'
                                      "
                                      :variant="
                                        activeItem.entityLevel ==
                                          entityLevel.ManufacturingSeries &&
                                        activeItem.ManufacturingSeriesId ==
                                          manufacturingSeries.ManufacturingSeriesId
                                          ? 'white'
                                          : ''
                                      "
                                      aria-hidden="true"
                                    ></b-icon>
                                  </b-button>
                                  <b-button
                                    v-else
                                    title="No Children"
                                    variant="link"
                                    size="sm"
                                  >
                                    <b-icon icon="blank"></b-icon>
                                  </b-button>
                                  {{ manufacturingSeries.DisplayName }}
                                </b-card-header>
                                <b-card-body
                                  :class="{
                                    'not-visible': !manufacturingSeries.Visible,
                                    'sub-category-tree':true
                                  }"
                                  v-if="manufacturingSeries.open"
                                  :key="
                                    'body' +
                                    manufacturingSeries.ManufacturingSeriesId
                                  "
                                  :body-border-variant="
                                    activeItem.entityLevel ==
                                      entityLevel.ManufacturingSeries &&
                                    activeItem.ManufacturingSeriesId ==
                                      manufacturingSeries.ManufacturingSeriesId
                                      ? 'primary'
                                      : 'secondary'
                                  "
                                >
                                  <b-row no-gutters style="width: 100%">
                                    <b-card no-body class="col-12">
                                      <template
                                        v-for="product in manufacturingSeries.Products"
                                      >
                                        <b-card-header
                                          :class="[
                                            'p-1',
                                            'card-header-mobile',
                                            { 'not-visible': !product.Visible },
                                            'button',
                                          ]"
                                          :key="'header' + product.ProductId"
                                          header-tag="h5"
                                          @click="
                                            clickProduct({
                                              category,
                                              productClass,
                                              manufacturingSeries,
                                              product,
                                            })
                                          "
                                        >
                                          <b-button
                                            :variant="
                                              activeItem.entityLevel ==
                                                entityLevel.Product &&
                                              activeItem.ProductId ==
                                                product.ProductId
                                                ? 'primary'
                                                : 'light'
                                            "
                                            class="card-header-mobile"
                                          >
                                            {{ product.DisplayName }}
                                          </b-button>
                                        </b-card-header>
                                      </template>
                                    </b-card>
                                  </b-row>
                                </b-card-body>
                              </template>
                            </b-card>
                          </b-row>
                        </b-card-body>
                      </template>
                    </b-card>
                  </b-row>
                </b-card-body>
              </template>
            </b-card>
          </b-row>
        </b-card-body>
      </b-card>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import LoadingText from '@/components/utility/loading-text.vue'

import {
  Category,
  ManufacturingSeries,
  Product,
  ProductClass,
  SectionTable,
  TPIException,
} from '@/store/editor/types'

import SectionComponent from '@/components/section.vue'
import { EntityLevel } from '@/store/types'
import MxSite from '@/mixins/site'

// and replace them with methods in:
const nsProduct = namespace('product')
const nsProductFinder = namespace('product-finder')

@Component({
  components: {
    'loading-text': LoadingText,
    'section-component': SectionComponent,
  },
})
export default class extends MxSite {
  public treeFilter = ''
  public entityLevel = EntityLevel

  @Prop()
  public setProductClassActive!: any

  @Prop()
  public toggleProductClassOpen!: any

  @Prop()
  public setManufacturingSeriesActive!: any

  @Prop()
  public toggleManufacturingSeriesOpen!: any

  @Prop()
  public setProductActive!: any

  @Prop()
  public activeItem!: any

  @Prop()
  public topologyTreeLoadding! : boolean

  @Prop()
  public treeCategories!: Category[]

  @Prop()
  public getTopology: any

  // Category
  @nsProductFinder.Action('setCategoryActive')
  private setCategoryActive!: any

  @nsProductFinder.Action('toggleCategoryOpen')
  public toggleCategoryOpen!: any

  @nsProduct.Action('getProduct')
  private getProduct: any

  @nsProduct.Action('getProductSections')
  private getProductSections: any

  @nsProduct.Action('loadImages')
  private loadImages: any

  @nsProduct.Action('loadTable')
  private loadTable: any

  @nsProduct.State('product')
  private product!: Product

  @nsProductFinder.Action('setProductSectionsLoading')
  private setProductSectionsLoading: any

  public mounted() {
    this.getTopology({})
  }

  public clickCategory({ category }: { category: Category }) {
    this.setCategoryActive({ category })
  }

  public clickProductClass({
    category,
    productClass,
  }: {
    category: Category
    productClass: ProductClass
  }) {
    this.setProductClassActive({ category, productClass })
  }

  public clickManufacturingSeries({
    category,
    productClass,
    manufacturingSeries,
  }: {
    category: Category
    productClass: ProductClass
    manufacturingSeries: ManufacturingSeries
  }) {
    this.setManufacturingSeriesActive({
      category,
      productClass,
      manufacturingSeries,
    })
  }

  public clickProduct2({
    category,
    productClass,
    manufacturingSeries,
    product,
  }: {
    category: Category
    productClass: ProductClass
    manufacturingSeries: ManufacturingSeries
    product: Product
  }) {
    this.setProductActive({
      category,
      productClass,
      manufacturingSeries,
      product,
    })
  }

  public clickProduct({
    category,
    productClass,
    manufacturingSeries,
    product,
  }: {
    category: Category
    productClass: ProductClass
    manufacturingSeries: ManufacturingSeries
    product: Product
  }) {
    const { clickProduct2 } = this
    setTimeout(() => {
      clickProduct2({ category, productClass, manufacturingSeries, product })
    }, 10)
    this.loadProduct(product.Name)
  }

  public highlightedTreeItem(
    item: Category | ProductClass | ManufacturingSeries | Product,
    entityLevel: EntityLevel,
  ): boolean {
    if (!this.treeFilter || this.treeFilter.length === 0) {
      return false
    }

    const regex = new RegExp(this.treeFilter, 'i')

    switch (
      entityLevel // we don't have time for breaks!
    ) {
      case EntityLevel.Category: {
        const category = item as Category
        return (
          regex.test(category.DisplayName) ||
          (category.ProductClasses &&
            category.ProductClasses.some(
              (pc) =>
                regex.test(pc.DisplayName) ||
                pc.ManufacturingSeries.some(
                  (ms) =>
                    regex.test(ms.DisplayName) ||
                    (ms.Products &&
                      ms.Products.some((p) => regex.test(p.DisplayName))),
                ),
            ))
        )
      }
      case EntityLevel.ProductClass: {
        const productClass = item as ProductClass
        return (
          regex.test(productClass.DisplayName) ||
          (productClass.ManufacturingSeries &&
            productClass.ManufacturingSeries.some(
              (ms) =>
                regex.test(ms.DisplayName) ||
                (ms.Products &&
                  ms.Products.some((p) => regex.test(p.DisplayName))),
            ))
        )
      }
      case EntityLevel.ManufacturingSeries: {
        const manufacturingSeries = item as ManufacturingSeries
        return (
          regex.test(manufacturingSeries.DisplayName) ||
          (manufacturingSeries.Products &&
            manufacturingSeries.Products.some((p) => regex.test(p.DisplayName)))
        )
      }
      case EntityLevel.Product: {
        const product = item as Product
        return regex.test(product.DisplayName)
      }
    }
    return false
  }

  public loadTables({
    routePcnCatalognumber,
  }: {
    routePcnCatalognumber: string
  }) {
    this.product.Sections.forEach((section) => {
      section.Tabs.forEach((sectionTab) => {
        sectionTab.Items.forEach((sectionItem) => {
          const sectionTable = sectionItem as SectionTable
          if (sectionTable.SectionTableId) {
            setTimeout(() =>
              this.loadTable({ routePcnCatalognumber, sectionTable }),
            )
          }
        })
      })
    })
  }

  public loadProduct(productName) {
    this.getProduct({ productName })
      .then(() => {
        this.setProductSectionsLoading(true)
        this.getProductSections({ productName }).then(() => {
          const loadTables = () => {
            this.loadTables({ routePcnCatalognumber: '' })
          }
          setTimeout(loadTables)
          this.setProductSectionsLoading(false)
        })

        const loadImages = () => {
          this.loadImages()
        }
        setTimeout(loadImages)
        this.$emit('showProductModels')
      })
      .catch((err: TPIException) => {
        this.toastError(err.Message)
        this.setProductSectionsLoading(false)
      })
  }
}
</script>
<style scoped>
.hide-not-visible .not-visible {
  display: none;
}

@media (max-width: 767px) {
  .category-tree {
    padding: 0 !important;
  }

  .sub-category-tree {
    padding: 10px !important;
  }

  .category-header {
    font-size: large;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
  }

  .card-header-mobile {
    font-size: medium;
  }
}
</style>
